import { getUserData } from '../../../constants/global';
import type { INotificationByIDResponse, INotificationResponse } from '../../../interface/state/INotificatIon';
import { notificationType } from '../../types';
import { getCommandQuery, type IGetQuery, type IResponse } from '../api-utils';
import * as utils from '../utils';

const roleQuery = () => {
	const userRoles = getUserData().user?.role as string[];
	if (Array.isArray(userRoles) && !userRoles?.length) return '';
	return userRoles?.map((role, index) => `Role=${role}${index === userRoles.length - 1 ? '' : '&'}`).join('');
};

export const getAll_Notification = ({ onFailure, onSuccess, query, paged }: IGetQuery<INotificationResponse>) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/Notification${getCommandQuery(paged, ...(query || []))}&${roleQuery()}`,
			header: utils.header(),
		},
		actionType: notificationType.getAll_Notification,
		onFailure,
		onSuccess,
	});
export const get_NotificationByID = ({ onFailure, onSuccess, id }: IResponse<INotificationByIDResponse> & { id: string }) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/Notification/${id}`,
			header: utils.header(),
		},
		actionType: notificationType.get_NotificationByID,
		onFailure,
		onSuccess,
	});

export const delete_Notification = ({ onFailure, onSuccess, id }: IResponse & { id: string }) =>
	utils.httpDeleteMethod({
		apiData: {
			url: `/api/v1/Notification/${id}`,
			header: utils.header(),
		},
		actionType: notificationType.delete_Notification,
		onFailure,
		onSuccess,
	});
